// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import BaseFolderItem from 'folder-items/BaseFolderItem';

import {assert} from 'Asserts';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderSelectorModalClass from 'file-browser/FolderSelectorModal';
import {getInsufficientPermissionsToEditMessage} from 'folder-items/FileUtil';
import {isComplexPolymer} from 'modbio/complex-polymers/ComplexPolymerUtil';

class BasicFolderItem extends BaseFolderItem {
  static initClass() {
    this.prototype.urlRoot = '/1/api/basic-folder-items';
  }

  initialize() {
    this.registerListeners();
    this.set({isLatest: true});
  }

  registerListeners() {
    // TODO: add `@on 'change', @updateStatusBar` once updateStatusBar is defined
  }

  cleanUp() {
    this.stopListening();
  }

  duplicate() {
    FolderSelectorModalClass.openForCopy(
      {
        showInventory: true,
        showNotebook: false,
      },
      (folderId) => {
        FileBrowserActions.copyAndOpenItem(this.id, folderId);
      }
    );
  }

  isLatest() {
    return this.get('isLatest');
  }

  setIsLatest(isLatest) {
    assert(isComplexPolymer(this.id), 'Basic folder item must be complex polymer to set version attribute');
    this.set({isLatest});
  }

  allowEditsToNote() {
    return this.isLatest() && super.allowEditsToNote();
  }

  getBannerText() {
    if (!this.isLatest()) {
      return 'Editing disabled on previous versions.';
    } else if (this.isArchived()) {
      return 'Editing disabled on archived entity.';
    }
    return getInsufficientPermissionsToEditMessage(this.permissions(), 'entity');
  }

  setBanner() {
    if (!this.writable() || !this.isLatest()) {
      this.setBannerText(this.getBannerText());
    } else {
      this.setBannerText(null);
    }
  }
}
BasicFolderItem.initClass();

export default BasicFolderItem;
